import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Footer as ToolkitFooter, A } from '@contently/toolkit';
import { connect } from 'react-redux';
import LocalizeLanguageSelector from './LocalizeLanguageSelector';
import * as actions from '../../store/actions';

const Footer = ({ userSignedIn, fetchUser }) => {
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const config = {
    copyright: 'Contently',
    listItems: [
      () =>
        window.env.LOCALIZE_JS_ENABLED === 'true' ? <LocalizeLanguageSelector /> : <Fragment />,
      () => (
        <A href="/terms" title="Terms of Service">
          Terms of Service
        </A>
      ),
      () => (
        <A href="/privacy-policy" title="Privacy Policy">
          Privacy Policy
        </A>
      ),
      () =>
        userSignedIn ? (
          <A href="https://help.contently.com/" title="Help">
            Help
          </A>
        ) : (
          <Fragment />
        )
    ]
  };
  return <ToolkitFooter config={config} />;
};

Footer.defaultProps = {
  userSignedIn: false
};

Footer.propTypes = {
  userSignedIn: PropTypes.bool,
  fetchUser: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  userSignedIn: state.user.signedIn
});

const mapDispatchToProps = dispatch => ({
  fetchUser: () => dispatch(actions.fetchUser())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);



// WEBPACK FOOTER //
// ./app/javascript/app/components/layout/Footer.jsx